module.exports = __webpack_public_path__ + "fonts/Roboto-Black.477571b.woff";